import marineRadar from '../Assets/images/marine-radar.jpg';
import vdr from '../Assets/images/vdr.jpg';
import gps from '../Assets/images/gps.jpg';
import echosounder from '../Assets/images/echosounder.jpg';
import sonar from '../Assets/images/sonar.jpg';
import speedlog from '../Assets/images/speedlog.jpg';
import gyrocompass from '../Assets/images/gyrocompass.jpg';
import autopilot from '../Assets/images/autopilot.jpg';
import magneticCompass from '../Assets/images/magnetic-compass.jpg';
import ais from '../Assets/images/ais.jpg';
import bnwas from '../Assets/images/bnwas.jpg';
import anomometer from '../Assets/images/anomometer.jpg';
import ecdis from '../Assets/images/ecdis.jpg';

const navProducts = [
    {
      id: 1,
      name: "Marine Radar",
      description: "Advanced radar systems for vessel navigation and collision avoidance",
      image: marineRadar,
      features: [
        "High resolution display",
        "Advanced target tracking",
        "Weather overlay",
        "Dual range scanning"
      ]
      ,specifications: [
        { name: "Display Size", value: "19 inch LCD" },
        { name: "Range", value: "96 nautical miles" },
        { name: "Power", value: "24V DC" },
        { name: "Resolution", value: "1920 x 1080 pixels" },
        { name: "Operating Temperature", value: "-15°C to +55°C" }
      ]
    },
    {
      id: 2, 
      name: "Voyage Data Recorder",
      description: "Complete voyage recording system for maritime safety and incident investigation",
      image: vdr,
      features: [
        "Continuous recording",
        "Data encryption",
        "Easy data retrieval",
        "Long-term storage"
      ]
    },
    {
      id: 3,
      name: "GPS/DGPS",
      description: "Precise positioning and navigation systems for marine vessels",
      image: gps, 
      features: [
        "High accuracy positioning",
        "DGPS corrections",
        "Multiple constellation support",
        "Route planning"
      ]
    },
    {
      id: 4,
      name: "Echosounder",
      description: "Depth measurement and seabed mapping system",
      image: echosounder,
      features: [
        "Digital depth reading",
        "Bottom hardness detection",
        "Fish finding capability",
        "Multiple frequency options"
      ]
    },
    {
      id: 5,
      name: "Sonar",
      description: "Advanced underwater detection and scanning system",
      image: sonar,
      features: [
        "360° scanning",
        "Multiple beam formation",
        "Target tracking",
        "High resolution imaging"
      ]
    },
    {
      id: 6,
      name: "Speed Log",
      description: "Accurate vessel speed measurement system",
      image: speedlog,
      features: [
        "Dual axis measurement",
        "Through water/ground speed",
        "Digital display",
        "Data logging"
      ]
    },
    {
      id: 7,
      name: "Gyrocompass",
      description: "High precision heading reference system",
      image: gyrocompass,
      features: [
        "True north reference",
        "High accuracy",
        "Multiple repeater output",
        "Auto correction"
      ]
    },
    {
      id: 8,
      name: "Autopilot",
      description: "Advanced automatic steering system",
      image: autopilot,
      features: [
        "Multiple steering modes",
        "Weather adaptable",
        "Track control",
        "Remote control capability"
      ]
    },
    {
      id: 9,
      name: "Magnetic Compass",
      description: "Traditional navigation equipment with modern features",
      image: magneticCompass,
      features: [
        "Reliable heading reference",
        "No power requirement",
        "Deviation compensation",
        "Night illumination"
      ]
    },
    {
      id: 10,
      name: "AIS",
      description: "Automatic Identification System for vessel tracking",
      image: ais,
      features: [
        "Real-time tracking",
        "Vessel information display",
        "Collision avoidance",
        "Data logging"
      ]
    },
    {
      id: 11,
      name: "BNWAS",
      description: "Bridge Navigational Watch Alarm System",
      image: bnwas,
      features: [
        "Watch keeper monitoring",
        "Multiple alarm stages",
        "Emergency notification",
        "Automatic mode switching"
      ]
    },
    {
      id: 12,
      name: "Anomometer",
      description: "Wind speed and direction measurement system",
      image: anomometer,
      features: [
        "Real-time wind data",
        "Digital display",
        "Data logging",
        "Multiple unit options"
      ]
    },
    {
      id: 13,
      name: "ECDIS",
      description: "Electronic Chart Display and Information System",
      image: ecdis,
      features: [
        "Electronic chart display",
        "Route planning",
        "Navigation tools",
        "Automatic updates"
      ]
    }
  ];
  
  export default navProducts;